import { trpc } from '@/shared/api';

/** 한 주문에 접수된 문의 목록(주문 상세 카드용). */
export const useOrderInquiriesByOrderQuery = (orderId: string) =>
  trpc.orderInquiryManagement.listByOrder.useQuery({ orderId });
